import analysisModule from "../analysisModule"
import server from "../../server"

analysisModule.service("nodeCommandBatchEdition", [
    "batchEditionModal",
    "remoteExceptionHandler",
    "loadingService",
    "$http",
    function (batchEditionModal, remoteExceptionHandler, loadingService, $http) {
        return function (selection, refilter) {
            return loadingService($http.post(server.getServiceUrl("batch-edition-dto"), selection).then(function (response) {
                return batchEditionModal(response.data, refilter)
            })).catch(remoteExceptionHandler())
        }
    }])